/**
 * This form validation is to look for all forms when .js-form is present. Right now it is built to look for 
 * required fields .js-sc-form-required which is a sitecore class but unsure if all forms will be sitecore forms
 */
export default function initFormValidation() {
  const validators = {
    email: (input) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value),
    password: (input) => input.value.length >= 6,
    zip: (input) => /^\d{5}(-\d{4})?$/.test(input.value),
    required: (input) => input.value.trim() !== '',
  };

  function validateInput(input, isRequired) {
    const type = input.getAttribute('type');
    const customRule = input.dataset.validate;
    const value = input.value.trim();

    if (isRequired && !validators.required(input)) {
      return 'Please fill out this field.';
    }

    if (type === 'email') {
      if (value && !validators.email(input)) {
        return `Please include an '@' in the email address. '${value}' is missing an '@'.`;
      }
    }

    if (type && validators[type] && !validators[type](input)) {
      return `Please enter a valid ${type}.`;
    }

    if (customRule && validators[customRule] && !validators[customRule](input)) {
      return `Please enter a valid ${customRule}.`;
    }

    return null;
  }


  function getOrCreateErrorElement(input) {
    const errorId = `${input.id}-description`;
    let errorEl = document.getElementById(errorId);

    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.id = errorId;
      errorEl.className = 'field-description field-invalid';
      errorEl.setAttribute('aria-live', 'polite');
      input.insertAdjacentElement('afterend', errorEl);
    }

    return errorEl;
  }

  function showOrClearError(input, isRequired) {
    const errorMsg = validateInput(input, isRequired);
    const errorEl = getOrCreateErrorElement(input);

    if (errorMsg) {
      input.classList.add('is-invalid');
      errorEl.textContent = errorMsg;
      errorEl.style.display = 'block';
    } else {
      input.classList.remove('is-invalid');
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }

    return !!errorMsg; // returns true if error exists
  }

  document.querySelectorAll('.js-form').forEach((form) => {
    const inputs = form.querySelectorAll('input, textarea, select');

    inputs.forEach((input) => {
      const label = form.querySelector(`label[for="${input.id}"]`);
      const isRequired = label?.classList.contains('js-sc-form-required');

      // Real-time validation on input and blur
      input.addEventListener('input', () => showOrClearError(input, isRequired));
      input.addEventListener('blur', () => showOrClearError(input, isRequired));
    });

    // Submit handler
    form.addEventListener('submit', function (e) {
      let hasErrors = false;

      inputs.forEach((input) => {
        const label = form.querySelector(`label[for="${input.id}"]`);
        const isRequired = label?.classList.contains('js-sc-form-required');
        const hasError = showOrClearError(input, isRequired);

        if (hasError) hasErrors = true;
      });

      if (hasErrors) {
        e.preventDefault();
      }
    });
  });
}
